define('home/models/ActivityFeed',[
    'underscore',

    'home/models/Feed',
    'home/collections/FeedItemCollection',
], function (
    _,

    Feed,
    FeedItemCollection
) {
    'use strict';

    var ActivityFeed = Feed.extend({
        initialize: function (attrs, options) {
            Feed.prototype.initialize.call(this, attrs, _.extend({
                collectionClass: FeedItemCollection,
            }, options));
        },
    });

    return ActivityFeed;
});

